export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1603219527847-24c87f552a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHwzfHxsZWF0aGVyJTIwbGFwdG9wJTIwYmFnJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjQ5Njk1NHww&ixlib=rb-4.1.0&q=85",
    laptopMen: "https://images.unsplash.com/photo-1637759292654-a12cb2be085e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwbGFwdG9wJTIwYmFnJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjQ5Njk1NHww&ixlib=rb-4.1.0&q=85",
    laptopWomen: "https://images.unsplash.com/photo-1691480150204-66dd1eb77391?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHwyfHxsZWF0aGVyJTIwbGFwdG9wJTIwYmFnJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjQ5Njk1NHww&ixlib=rb-4.1.0&q=85",
    sling: "https://images.unsplash.com/photo-1657603738389-951c374b740c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHw0fHxsZWF0aGVyJTIwbGFwdG9wJTIwYmFnJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjQ5Njk1NHww&ixlib=rb-4.1.0&q=85",
    wallets: "https://images.pexels.com/photos/12442665/pexels-photo-12442665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    candles: "https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxoYW5kbWFkZSUyMGNhbmRsZXMlMjBsdXh1cnklMjBzY2VudGVkfGVufDB8fHx8MTc5MjQ5Njk1NXww&ixlib=rb-4.1.0&q=85",
    magnets: "https://images.pexels.com/photos/8099158/pexels-photo-8099158.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    artisan: "https://images.pexels.com/photos/37076986/pexels-photo-37076986.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tools: "https://images.unsplash.com/photo-1628483211662-9bcc692c46dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NjV8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwY3JhZnQlMjB3b3Jrc2hvcCUyMGFydGlzYW58ZW58MHx8fHwxNzkyNDk2OTU1fDA&ixlib=rb-4.1.0&q=85",
};

// Owner's real inbox — enquiry alerts and site contact
export const WHATSAPP_NUMBER = "919643022409";
export const WHATSAPP_NUMBER_2 = "+91 88005 02883";
export const WHATSAPP_DISPLAY = "+91 96430 22409";
export const CONTACT_EMAIL = "exports@fnbinternational.com";

export const CATEGORIES = [
    "Leather Laptop Bags",
    "Leather Sling Bags",
    "Travel & Duffle Bags",
    "Men's Wallets",
    "Handmade Candles",
    "Fridge Magnets",
    "Custom / OEM",
];

export const NAV_LINKS = [
    { id: "collections", label: "Collections" },
    { id: "gallery", label: "Gallery" },
    { id: "craft", label: "Craft Story" },
    { id: "markets", label: "Global Markets" },
    { id: "enquiry", label: "Contact" },
];
